// extracted by mini-css-extract-plugin
export var active = "_li-e";
export var blink = "_li-f";
export var dropDownSelector = "_li-5";
export var dropDownWrapper = "_li-4";
export var fakeCursor = "_li-d";
export var fontSizeButton = "_li-7";
export var formQuillEditor = "_li-0";
export var pressed = "_li-g";
export var qlBlank = "_li-1";
export var textFormattingToolbar = "_li-2";
export var textFormattingToolbarClosed = "_li-3";
export var textFormattingToolbarInline = "_li-6";
export var textToolbarOption = "_li-8";
export var toolbarCell = "_li-a";
export var toolbarCellCollapsed = "_li-b";
export var toolbarOptionHitArea = "_li-c";
export var toolbarOverflow = "_li-9";